module.exports = __webpack_public_path__ + "img/perspectives-slide06.c4081b04.jpg";